import { render, staticRenderFns } from "./ProjectText.vue?vue&type=template&id=1602aba0&scoped=true&"
import script from "./ProjectText.vue?vue&type=script&lang=js&"
export * from "./ProjectText.vue?vue&type=script&lang=js&"
import style0 from "./ProjectText.vue?vue&type=style&index=0&id=1602aba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1602aba0",
  null
  
)

export default component.exports